import logo from '../assets/logo.jpeg';

export default function AuthLayout({ children }) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px 16px',
      background: 'var(--color-bg)',
      backgroundImage: `
        radial-gradient(ellipse 80% 60% at 50% -20%, rgba(22,163,74,0.08) 0%, transparent 70%),
        radial-gradient(ellipse 40% 40% at 80% 80%, rgba(22,163,74,0.05) 0%, transparent 60%)
      `,
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          
          {/* 🔥 LOGO */}
          <img 
            src={logo}
            alt="Logo"
            style={{
              width: 125,
              height: 110,
              borderRadius: 16,
              marginBottom: 14,
              objectFit: 'cover',
              boxShadow: '0 4px 20px rgba(22,163,74,0.3)'
            }}
          />

          {/*<h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 28,
            fontWeight: 600,
            color: 'var(--color-text)',
            lineHeight: 1.2,
          }}>
            BONZAI
          </h1>*/}

          <p style={{ fontSize: 14, color: 'var(--color-muted)', marginTop: 4 }}>
            Tu dinero, bajo control
          </p>
        </div>

        <div style={{
          background: 'var(--color-surface)',
          borderRadius: 'var(--radius-lg)',
          padding: '32px 28px',
          boxShadow: 'var(--shadow-card)',
          border: '1px solid var(--color-border)',
        }}>
          {children}
        </div>

        <p style={{
          textAlign: 'center',
          fontSize: 12,
          color: 'var(--color-muted)',
          marginTop: 20,
        }}>
          © 2026 Calypso · Hecho con ❤️
        </p>

      </div>
    </div>
  )
}